module.exports = __webpack_public_path__ + "img/dsci0007.28b34040.jpg";